import { useCallback, useContext, useState } from "react";
import { CategoriesService } from "../../../../../core/http/services/CategoriesService";
import AuthContext from "@/contexts/AuthContext";
import { useParams } from "react-router-dom";

const useCategories = () => {
  const { userLoggedData } = useContext(AuthContext);
  const { clubId: clubIdFromUrl } = useParams();
  const clubId = clubIdFromUrl || userLoggedData?.selectedClubId || null;

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ type: null, message: null });

  const fetchCategories = useCallback(async () => {
    if (!clubId) return;
    setLoading(true);
    setError({ type: null, message: null });

    const { status, data, message } = await CategoriesService.get(clubId);

    if (status !== 200) {
      setError({ type: "categories", message });
      setLoading(false);
      return;
    }

    setCategories(data ?? []);
    setLoading(false);
  }, [clubId]);

  return { categories, setCategories, loading, error, fetchCategories };
};

export default useCategories;
